<template>
  <section id="home">
    <div class="container-fluid p-0">

      <!-- Hero / Community Section -->
      <section class="section-spacing">
        <CommunitySection></CommunitySection>
      </section>

      <!-- Qui sommes-nous (resume) -->
      <section class="about-preview" data-aos="fade-up">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-6 mb-4 mb-lg-0">
              <div class="about-img-wrapper">
                <img src="../assets/img/prefereplus.png" alt="Equipe PREFERE PLUS" class="about-img" />
              </div>
            </div>
            <div class="col-lg-6">
              <div class="label-badge">Depuis 2012</div>
              <h2 class="section-title">Qui sommes-nous ?</h2>
              <p class="section-text">
                Le cabinet <strong>PREFERE PLUS</strong> developpe et distribue des solutions adaptees et sur mesure
                en <strong>Management des Ressources Humaines</strong>. Notre large gamme de solutions en GRH et de
                services associes nous permet de vous accompagner sur l'ensemble de vos problematiques.
              </p>
              <div class="key-numbers">
                <div class="key-number" v-for="(item, index) in keyNumbers" :key="index">
                  <span class="number">{{ item.value }}</span>
                  <span class="label">{{ item.label }}</span>
                </div>
              </div>
              <router-link to="/about" class="btn-more">
                En savoir plus <i class="fas fa-arrow-right ms-2"></i>
              </router-link>
            </div>
          </div>
        </div>
      </section>

      <!-- Domaines d'expertise -->
      <section class="expertise-section" data-aos="fade-up">
        <div class="container">
          <div class="text-center mb-5">
            <div class="label-badge center">Nos competences</div>
            <h2 class="section-title">Domaines d'expertise</h2>
            <p class="section-subtitle">Une expertise complete en management des ressources humaines</p>
          </div>
          <div class="expertise-grid">
            <div v-for="(item, index) in expertiseDomains" :key="index"
                 class="expertise-item"
                 :data-aos="'fade-up'"
                 :data-aos-delay="index * 60">
              <div class="expertise-icon" :style="{ background: index % 2 === 0 ? '#29b3cd15' : '#e95d1615' }">
                <i :class="item.icon" :style="{ color: index % 2 === 0 ? '#29b3cd' : '#e95d16' }"></i>
              </div>
              <span>{{ item.title }}</span>
            </div>
          </div>
          <div class="text-center mt-4">
            <router-link to="/services" class="btn-more">
              Voir tous nos services <i class="fas fa-arrow-right ms-2"></i>
            </router-link>
          </div>
        </div>
      </section>

      <!-- Offres d'emploi -->
      <section class="section-spacing">
        <JobOffersSection></JobOffersSection>
      </section>

      <!-- Formations a venir -->
      <section class="formations-preview" data-aos="fade-up">
        <div class="container">
          <div class="text-center mb-5">
            <div class="label-badge center">Nouveau</div>
            <h2 class="section-title">Prochaines formations</h2>
            <p class="section-subtitle">Inscrivez-vous a nos prochaines sessions de formation inter-entreprises</p>
          </div>
          <div class="formations-grid">
            <div v-for="(f, index) in upcomingFormations" :key="index"
                 class="formation-card"
                 :data-aos="'fade-up'"
                 :data-aos-delay="index * 80">
              <div class="formation-month">{{ f.month }}</div>
              <h4>{{ f.theme }}</h4>
              <div class="formation-meta">
                <span><i class="fas fa-calendar"></i> {{ f.periode }}</span>
                <span><i class="fas fa-map-marker-alt"></i> {{ f.lieu }}</span>
              </div>
              <span class="formation-price">A partir de <strong>250 000 FCFA</strong></span>
            </div>
          </div>
          <div class="text-center mt-4">
            <router-link to="/formations" class="btn-cta">
              <i class="fas fa-graduation-cap me-2"></i>Voir tout le catalogue 2026
            </router-link>
          </div>
        </div>
      </section>

      <!-- Processus + Services -->
      <section class="section-spacing">
        <SectionTwo></SectionTwo>
      </section>

      <!-- Valeurs DEFI -->
      <section class="values-section" data-aos="fade-up">
        <div class="container">
          <div class="text-center mb-5">
            <div class="label-badge center">Ce qui nous anime</div>
            <h2 class="section-title">Nos valeurs : <span class="text-accent">D.E.F.I</span></h2>
          </div>
          <div class="values-grid">
            <div v-for="(v, index) in values" :key="index" class="value-card" :data-aos="'zoom-in'" :data-aos-delay="index * 120">
              <div class="value-letter" :style="{ background: v.color }">{{ v.letter }}</div>
              <h4>{{ v.title }}</h4>
              <p>{{ v.desc }}</p>
            </div>
          </div>
        </div>
      </section>

      <!-- Partenaires -->
      <section class="partners-section" data-aos="fade-up">
        <div class="container">
          <div class="text-center mb-4">
            <div class="label-badge center">Confiance</div>
            <h2 class="section-title">Ils nous font confiance</h2>
          </div>
          <div class="partners-scroll">
            <div class="partners-track">
              <div v-for="(partner, index) in partners" :key="index" class="partner-logo" :title="partner.name">
                <img :src="partner.logo" :alt="partner.name" loading="lazy" @error="onLogoError" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- CTA Final -->
      <section class="cta-final" data-aos="fade-up">
        <div class="container">
          <div class="cta-box">
            <h2>Pret a booster votre performance ?</h2>
            <p>Contactez notre equipe pour discuter de vos besoins en recrutement, formation ou conseil RH</p>
            <div class="cta-buttons">
              <router-link to="/contact" class="btn btn-cta-primary">
                <i class="fas fa-paper-plane me-2"></i>Nous contacter
              </router-link>
              <a href="tel:+22901401188884" class="btn btn-cta-secondary">
                <i class="fas fa-phone-alt me-2"></i>01 40 11 88 84
              </a>
            </div>
          </div>
        </div>
      </section>

    </div>
  </section>
</template>

<script>
import AOS from "aos";
import "aos/dist/aos.css";
import SectionTwo from "../components/SectionTwo.vue";
import JobOffersSection from "../components/JobOffersSection.vue";
import CommunitySection from "../components/CommunitySection.vue";

export default {
  components: {
    SectionTwo,
    JobOffersSection,
    CommunitySection
  },
  computed: {
    partners() {
      const base = process.env.VUE_APP_API_ENDPOINT || '';
      return this.partnerFiles.map(p => ({
        name: p.name,
        logo: `${base}/images/partners/${p.file}`
      }));
    }
  },
  data() {
    return {
      keyNumbers: [
        { value: "14+", label: "Annees" },
        { value: "2000+", label: "Heures de formation" },
        { value: "50+", label: "Partenaires" },
      ],
      expertiseDomains: [
        { icon: "fas fa-user-tie", title: "Recrutement & Chasse de tete" },
        { icon: "fas fa-graduation-cap", title: "Formation & Coaching" },
        { icon: "fas fa-tools", title: "Etudes & Developpement d'outils" },
        { icon: "fas fa-users-cog", title: "Conseils en GRH" },
        { icon: "fas fa-chart-line", title: "Evaluation de projets" },
        { icon: "fas fa-lightbulb", title: "Recherche & Developpement" },
        { icon: "fas fa-people-arrows", title: "Interim & Personnel" },
        { icon: "fas fa-file-contract", title: "Documents RH" },
        { icon: "fas fa-cogs", title: "Consulting & Ingenierie RH" },
        { icon: "fas fa-calculator", title: "Gestion financiere" },
        { icon: "fas fa-boxes", title: "Inventaire & Stocks" },
      ],
      upcomingFormations: this.getUpcomingFormations(),
      values: [
        { letter: "D", title: "Durabilite", desc: "Partenariats solides et solutions perennes", color: "linear-gradient(135deg, #29b3cd, #1d9ed9)" },
        { letter: "E", title: "Expertise", desc: "+20 ans d'experience, formateurs certifies", color: "linear-gradient(135deg, #e95d16, #bc6a3c)" },
        { letter: "F", title: "Flexibilite", desc: "Solutions adaptees a chaque contexte", color: "linear-gradient(135deg, #29b3cd, #1d9ed9)" },
        { letter: "I", title: "Innovation", desc: "Outils digitaux et management moderne", color: "linear-gradient(135deg, #e95d16, #bc6a3c)" },
      ],
      partnerFiles: [
        { name: "MTN Benin", file: "MTNBENIN.png" },
        { name: "GIZ", file: "giz.png" },
        { name: "Sodeco", file: "sodeco.png" },
        { name: "Orabank", file: "orabank.jpg" },
        { name: "SBIN", file: "sbin.png" },
        { name: "Bank of Africa", file: "BOA.png" },
        { name: "Benin Control", file: "BC.png" },
        { name: "SIRAT", file: "SIRAT.png" },
        { name: "CRS", file: "CSR.png" },
        { name: "ATT", file: "ATT.png" },
        { name: "CNLS-TP", file: "CNLS.png" },
        { name: "CMA-Benin", file: "CMA.png" },
        { name: "ANSSI", file: "anssi.png" },
        { name: "ENGIE", file: "engie.png" },
        { name: "SIMAU", file: "simau.png" }
      ],
    };
  },
  mounted() {
    document.querySelector("body").style.backgroundColor = "#ffffff";
    // AOS initialise globalement dans main.js
    this.$nextTick(() => AOS.refresh());
    this.loadUpcomingFromAPI();
  },
  methods: {
    onLogoError(e) {
      // Masque le logo si l'image ne peut pas etre chargee
      const wrapper = e.target.closest('.partner-logo');
      if (wrapper) wrapper.style.display = 'none';
    },
    getUpcomingFormations() {
      const allFormations = [
        { month: "AVR", theme: "Techniques d'accueil des usagers et qualite de service", periode: "08-10 Avril", lieu: "Cotonou", endDate: "2026-04-10" },
        { month: "AVR", theme: "Gestion efficace des reunions", periode: "15-17 Avril", lieu: "Cotonou", endDate: "2026-04-17" },
        { month: "AVR", theme: "Sauveteur et secourisme au travail", periode: "22-24 Avril", lieu: "Cotonou", endDate: "2026-04-24" },
        { month: "AVR", theme: "Safety / Securite", periode: "27-29 Avril", lieu: "Cotonou", endDate: "2026-04-29" },
        { month: "MAI", theme: "Developpement des competences et gestion de la performance", periode: "05-07 Mai", lieu: "Cotonou", endDate: "2026-05-07" },
        { month: "MAI", theme: "Passation des marches publics : Procedures, Outils et Techniques", periode: "11-13 Mai", lieu: "Cotonou", endDate: "2026-05-13" },
        { month: "MAI", theme: "ISO 27001 : Lead Auditor avec Certification", periode: "18-20 Mai", lieu: "Cotonou", endDate: "2026-05-20" },
        { month: "MAI", theme: "Le digital au service des professionnels RH", periode: "22-29 Mai", lieu: "Cotonou", endDate: "2026-05-29" },
        { month: "JUN", theme: "Marches publics et procedures des bailleurs de fonds", periode: "03-05 Juin", lieu: "Cotonou", endDate: "2026-06-05" },
        { month: "JUN", theme: "Sage paie i7 pour professionnel RH", periode: "09-11 Juin", lieu: "Cotonou", endDate: "2026-06-11" },
        { month: "JUL", theme: "Gestion des chaines d'approvisionnement", periode: "07-09 Juillet", lieu: "Cotonou", endDate: "2026-07-09" },
        { month: "JUL", theme: "Leadership et performance strategique", periode: "15-17 Juillet", lieu: "Cotonou", endDate: "2026-07-17" },
      ];
      const now = new Date();
      return allFormations.filter(f => new Date(f.endDate) >= now).slice(0, 4);
    },
    async loadUpcomingFromAPI() {
      try {
        const apiBase = process.env.VUE_APP_API_ENDPOINT + '/api/trainings/upcoming?limit=4';
        const response = await this.axios.get(apiBase, { baseURL: '' });
        if (response.data && response.data.data && response.data.data.trainings) {
          const monthAbbr = ["JAN","FEV","MAR","AVR","MAI","JUN","JUL","AOU","SEP","OCT","NOV","DEC"];
          const monthNames = ["Janvier","Fevrier","Mars","Avril","Mai","Juin","Juillet","Aout","Septembre","Octobre","Novembre","Decembre"];
          this.upcomingFormations = response.data.data.trainings.map(t => {
            const start = new Date(t.start_date);
            const end = new Date(t.end_date);
            const mi = start.getMonth();
            return {
              month: monthAbbr[mi],
              theme: t.title,
              periode: `${String(start.getDate()).padStart(2,'0')}-${String(end.getDate()).padStart(2,'0')} ${monthNames[mi]}`,
              lieu: t.location,
              endDate: t.end_date
            };
          });
        }
      } catch (e) {
        // Fallback: donnees hardcodees deja chargees
      }
    }
  },
};
</script>

<style scoped>
.section-spacing {
  margin: 50px 0;
}

/* Labels & Titles */
.label-badge {
  display: inline-block;
  background: linear-gradient(135deg, #29b3cd, #1d9ed9);
  color: white;
  padding: 4px 14px;
  border-radius: 20px;
  font-size: 0.78rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 0.8rem;
}

.label-badge.center {
  margin-left: auto;
  margin-right: auto;
}

.section-title {
  font-family: 'Poppins', sans-serif;
  font-size: 2rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 0.5rem;
}

.section-subtitle {
  font-family: 'Poppins', sans-serif;
  color: #6c757d;
  font-size: 1rem;
  max-width: 550px;
  margin: 0 auto;
}

.section-text {
  font-family: 'Poppins', sans-serif;
  font-size: 1rem;
  color: #4a5568;
  line-height: 1.7;
}

.text-accent {
  color: #e95d16;
}

/* About Preview */
.about-preview {
  padding: 5rem 0;
  background: #f8f9fa;
}

.about-img-wrapper {
  text-align: center;
}

.about-img {
  max-width: 380px;
  width: 100%;
  border-radius: 16px;
}

.key-numbers {
  display: flex;
  gap: 1.5rem;
  margin: 1.5rem 0;
  flex-wrap: wrap;
}

.key-number {
  display: flex;
  flex-direction: column;
}

.key-number .number {
  font-size: 1.8rem;
  font-weight: 800;
  color: #29b3cd;
  line-height: 1;
}

.key-number .label {
  font-size: 0.8rem;
  color: #6c757d;
  font-weight: 500;
}

.btn-more {
  display: inline-flex;
  align-items: center;
  color: #29b3cd;
  font-weight: 600;
  font-size: 0.95rem;
  text-decoration: none;
  transition: all 0.3s;
  font-family: 'Poppins', sans-serif;
}

.btn-more:hover {
  color: #e95d16;
  gap: 4px;
}

/* Expertise */
.expertise-section {
  padding: 5rem 0;
}

.expertise-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
}

.expertise-item {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 0.8rem 1.2rem;
  background: white;
  border-radius: 12px;
  border: 1px solid #eef2f6;
  transition: all 0.3s;
  font-family: 'Poppins', sans-serif;
  font-size: 0.88rem;
  font-weight: 500;
  color: #2c3e50;
}

.expertise-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0,0,0,0.06);
  border-color: #29b3cd40;
}

.expertise-icon {
  width: 40px;
  height: 40px;
  min-width: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.expertise-icon i {
  font-size: 1rem;
}

/* Formations Preview */
.formations-preview {
  padding: 5rem 0;
  background: #f8f9fa;
}

.formations-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 1.2rem;
}

.formation-card {
  background: white;
  border-radius: 14px;
  padding: 1.5rem;
  border: 1px solid #eef2f6;
  transition: all 0.3s;
  font-family: 'Poppins', sans-serif;
}

.formation-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(0,0,0,0.08);
  border-color: #29b3cd40;
}

.formation-month {
  display: inline-block;
  background: #e95d16;
  color: white;
  padding: 2px 12px;
  border-radius: 6px;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 1px;
  margin-bottom: 0.6rem;
}

.formation-card h4 {
  font-size: 0.92rem;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 0.6rem;
  line-height: 1.4;
}

.formation-meta {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  margin-bottom: 0.6rem;
}

.formation-meta span {
  font-size: 0.82rem;
  color: #6c757d;
}

.formation-meta i {
  color: #29b3cd;
  width: 18px;
  margin-right: 4px;
}

.formation-price {
  font-size: 0.82rem;
  color: #4a5568;
}

.formation-price strong {
  color: #e95d16;
}

.btn-cta {
  display: inline-flex;
  align-items: center;
  background: linear-gradient(135deg, #29b3cd, #1d9ed9);
  color: white;
  padding: 12px 28px;
  border-radius: 50px;
  font-weight: 600;
  font-size: 0.95rem;
  text-decoration: none;
  transition: all 0.3s;
  border: none;
  font-family: 'Poppins', sans-serif;
  box-shadow: 0 4px 15px rgba(41,179,205,0.3);
}

.btn-cta:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(41,179,205,0.4);
  color: white;
}

/* Values */
.values-section {
  padding: 5rem 0;
}

.values-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1.2rem;
}

.value-card {
  text-align: center;
  padding: 2rem 1.5rem;
  background: white;
  border-radius: 16px;
  border: 1px solid #eef2f6;
  transition: all 0.3s;
  font-family: 'Poppins', sans-serif;
}

.value-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 30px rgba(0,0,0,0.08);
}

.value-letter {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.6rem;
  font-weight: 800;
  margin: 0 auto 0.8rem;
}

.value-card h4 {
  font-weight: 700;
  margin-bottom: 0.3rem;
  color: #2c3e50;
  font-size: 1rem;
}

.value-card p {
  font-size: 0.85rem;
  color: #6c757d;
  margin: 0;
}

/* Partners */
.partners-section {
  padding: 4rem 0;
  background: #f8f9fa;
}

.partners-scroll {
  overflow: hidden;
}

.partners-track {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 1.5rem 2rem;
}

.partner-logo {
  width: 130px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border: 1px solid #eef2f6;
  border-radius: 10px;
  padding: 10px 14px;
  transition: all 0.3s;
  filter: grayscale(60%);
  opacity: 0.85;
}

.partner-logo img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
}

.partner-logo:hover {
  filter: grayscale(0%);
  opacity: 1;
  transform: translateY(-3px);
  box-shadow: 0 6px 18px rgba(0,0,0,0.08);
  border-color: #29b3cd40;
}

@media (max-width: 576px) {
  .partner-logo {
    width: 110px;
    height: 60px;
  }
}

/* CTA Final */
.cta-final {
  padding: 3rem 0 5rem;
}

.cta-box {
  text-align: center;
  padding: 3rem 2rem;
  background: linear-gradient(135deg, #29b3cd, #1d9ed9);
  border-radius: 20px;
  color: white;
}

.cta-box h2 {
  color: white;
  font-family: 'Poppins', sans-serif;
  font-size: 1.8rem;
  font-weight: 700;
}

.cta-box p {
  color: rgba(255,255,255,0.9);
  font-size: 1rem;
  margin-bottom: 1.5rem;
  font-family: 'Poppins', sans-serif;
}

.cta-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.btn-cta-primary {
  background: #e95d16;
  color: white;
  padding: 12px 28px;
  border-radius: 50px;
  font-weight: 600;
  border: 2px solid #e95d16;
  transition: all 0.3s;
  text-decoration: none;
  font-family: 'Poppins', sans-serif;
}

.btn-cta-primary:hover {
  background: white;
  color: #e95d16;
}

.btn-cta-secondary {
  background: transparent;
  color: white;
  padding: 12px 28px;
  border-radius: 50px;
  font-weight: 600;
  border: 2px solid white;
  transition: all 0.3s;
  text-decoration: none;
  font-family: 'Poppins', sans-serif;
}

.btn-cta-secondary:hover {
  background: white;
  color: #29b3cd;
}

/* Responsive */
@media (max-width: 991px) {
  .section-title { font-size: 1.6rem; }
  .about-img { max-width: 300px; }
}

@media (max-width: 768px) {
  .section-title { font-size: 1.4rem; }
  .about-preview, .expertise-section, .formations-preview, .values-section, .partners-section { padding: 3rem 0; }
  .values-grid { grid-template-columns: repeat(2, 1fr); }
  .cta-box { padding: 2rem 1rem; }
  .cta-box h2 { font-size: 1.4rem; }
  .formations-grid { grid-template-columns: 1fr; }
}

@media (max-width: 575px) {
  .section-title { font-size: 1.3rem; }
  .formations-grid { grid-template-columns: 1fr; }
  .about-img { max-width: 100%; }
  .cta-box h2 { font-size: 1.2rem; }
  .cta-box { padding: 1.5rem 1rem; }
  .btn-cta-primary, .btn-cta-secondary { padding: 10px 20px; font-size: 0.9rem; }
  .partner-logo { width: 90px; height: 50px; }
}

@media (max-width: 480px) {
  .values-grid { grid-template-columns: 1fr; }
  .key-numbers { flex-direction: column; gap: 0.8rem; }
}
</style>
